import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// i18nextの初期化
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "ja", // フォールバック言語
    ns: ["common", "admin", "voiceek_ui"], // 使用する名前空間
    defaultNS: "common", // デフォルトの名前空間
    interpolation: {
      escapeValue: false, // Reactは既にXSS対策を行っているため
    },
    react: {
      useSuspense: true, // Suspenseを使用する
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${import.meta.env.VITE_BUILD_ID || Date.now()}`, // 言語ファイルのパス（キャッシュバスティング用のビルドID付き）
    },
  });

export default i18n;
